"use strict";
exports.__esModule = true;
var ChartScopeRequest = /** @class */ (function () {
    function ChartScopeRequest(_a) {
        var from = _a.from, to = _a.to, frequency = _a.frequency;
        var _this = this;
        this.toJSON = function () { return ({
            from: _this.from,
            to: _this.to,
            frequency: _this.frequency
        }); };
        this.from = from;
        this.to = to;
        this.frequency = frequency;
    }
    ChartScopeRequest.fromJSON = function (json) {
        var _a = Object.assign({}, json), from = _a.from, to = _a.to, frequency = _a.frequency;
        if (typeof from !== 'string')
            throw new Error('.from must be a string');
        if (typeof to !== 'string')
            throw new Error('.to must be a string');
        if (frequency !== 'DAILY' &&
            frequency !== 'WEEKLY' &&
            frequency !== 'MONTHLY' &&
            frequency !== null &&
            frequency !== undefined)
            throw new Error('.frequency must be a FrequencyValue or undefined or null');
        return new ChartScopeRequest({
            from: from,
            to: to,
            frequency: frequency
        });
    };
    return ChartScopeRequest;
}());
exports["default"] = ChartScopeRequest;
